import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'hostOrganization';

export const actionTypes = {
  CHECK_ORGANIZATION_STATUS: `${FEATURE_NAME}/CHECK_ORGANIZATION_STATUS`,
  FETCH_MY_ORGANIZATION: `${FEATURE_NAME}/FETCH_MY_ORGANIZATION`,
  FETCH_ORGANIZATION_BY_ID: `${FEATURE_NAME}/FETCH_ORGANIZATION_BY_ID`,
  CREATE_ORGANIZATION: `${FEATURE_NAME}/CREATE_ORGANIZATION`,
  UPDATE_ORGANIZATION: `${FEATURE_NAME}/UPDATE_ORGANIZATION`,
  FETCH_MEMBERS: `${FEATURE_NAME}/FETCH_MEMBERS`,
  INVITE_MEMBER: `${FEATURE_NAME}/INVITE_MEMBER`,
  REMOVE_MEMBER: `${FEATURE_NAME}/REMOVE_MEMBER`,
  RESEND_INVITATION: `${FEATURE_NAME}/RESEND_INVITATION`,
  DELETE_PENDING_INVITATION: `${FEATURE_NAME}/DELETE_PENDING_INVITATION`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
